import { StorageService } from 'src/app/services/storage.service';
import { FazendaService } from './../../../services/fazenda.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Fazenda } from 'src/app/classes/Fazenda';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-select-fazenda',
  templateUrl: './select-fazenda.component.html',
  styleUrls: ['./select-fazenda.component.scss']
})
export class SelectFazendaComponent implements OnInit {

  @Input() isSubmit: boolean;
  @Input() fazendaId: number | number[];
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() auxClass: string;
  @Input() multiple: boolean = false;
  @Input() ocultarMsgObrigatorio: boolean = false;
  @Output() fazendaChange: EventEmitter<number | number[]> = new EventEmitter();
  @Input() fazendas: Fazenda[];
  @Input() hideLabel: boolean;
  @Input() hideIcone: boolean;
  @Input() forcarTodas: boolean;
  @Input() exibirIcone: boolean = true;

  constructor(private fazendaService: FazendaService,
              private storageService: StorageService,
              private utilsService: UtilsService) { }

  ngOnInit() {
    if(!this.fazendaId)
    {
      if(this.multiple)
        this.fazendaId = [];
      else
        this.fazendaId = this.storageService.getFazenda() ? this.storageService.getFazenda().Id : 0;
      this.fazendaChange.emit(this.fazendaId);
    }

    if(!this.fazendas){
      this.fazendaService.getFazendas().subscribe(ret =>{
        this.fazendas = ret;
      }, err =>{
        this.utilsService.getErro(err);
      });
    }

    let usuario  = this.storageService.getUsuario();
    if(!usuario.PermissaoUsuario.AcessoTodasFazendas && !this.forcarTodas){
      this.fazendas = [];
      this.fazendas.push(this.storageService.getFazenda());
      this.disabled = true;
    }
  }

  onChange(){
    // Quando limpar a seleção, atribui 0 ao invés de null/undefined
    if (this.multiple) {
      if (!this.fazendaId || (Array.isArray(this.fazendaId) && this.fazendaId.length === 0)) {
        this.fazendaId = [];
      }
    } else {
      if (this.fazendaId === null || this.fazendaId === undefined) {
        this.fazendaId = 0;
      }
    }
    this.fazendaChange.emit(this.fazendaId);
  }

  onClear(){
    // Quando o usuário clica no X para limpar, força o valor para 0
    if (this.multiple) {
      this.fazendaId = [];
    } else {
      this.fazendaId = 0;
    }
    this.fazendaChange.emit(this.fazendaId);
  }

}
